import React from "react";
import "./ColumnIcon.css";

interface ColumnIconProps {
    columns: number;
    selected?: boolean;
    onClick?: () => void;
}

export const ColumnIcon = (props: ColumnIconProps) => {
    const { columns, selected, onClick } = props;

    const squares = Array.from({ length: columns * columns });

    return (
        <div className={`column-icon cols-${columns} ${selected ? "selected" : ""}`} onClick={onClick}>
            {squares.map((_, i) => (
                <div className="square" key={i} />
            ))}
        </div>
    );
};
